export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}common/common`;
    return $resource(url, null, {
        timestamp: {
            method: 'GET',
            url: `${url}/timestamp`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Common/index.js